module.exports = __webpack_public_path__ + "img/Cultura_oct_2023.53456a83.png";